// Types
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const SELECT_IBAN_FOOTER_ACTION_PROPS = {
  'data-testid': 'select-iban-footer-action',
  'variant': 'ACTION_BUTTONS',
};
const SELECT_IBAN_FOOTER_ACTION_LINK_PROPS = {
  'data-testid': 'select-iban-footer-action-link',
  'type': 'SECONDARY',
  'size': 'LARGE',
  'disabled': false,
};
const SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS = {
  'data-testid': 'select-iban-footer-action-button',
  'type': 'PRIMARY',
  'size': 'LARGE',
};
const FINANCIAL_DATA_PROPS = {
  showLink: false,
  showTooltip: false,
};
const SIGNING_TITLE_PROPS = {
  weight: VARIANTS.ParagraphWeightType.BOLD,
};

const PRIVACY_POLICY_LINK_PROPS = {
  target: 'BLANK',
  type: 'PRIMARY',
};

export {
  FINANCIAL_DATA_PROPS,
  PRIVACY_POLICY_LINK_PROPS,
  SELECT_IBAN_FOOTER_ACTION_PROPS,
  SELECT_IBAN_FOOTER_ACTION_LINK_PROPS,
  SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS,
  SIGNING_TITLE_PROPS,
};
